import { Link } from 'react-router-dom';
import type { Work } from '@/mocks/works';

export default function WorkCard({ work }: { work: Work }) {
  return (
    <Link
      to={`/detail/work/${work.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={work.cover}
          alt={`${work.title} 封面`}
          title={`${work.title} 小仓优子影视作品`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500/90 text-background-50 text-xs">
          {work.type}
        </span>
      </div>
      <div className="p-4">
        <h4 className="font-heading text-base text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {work.title}
        </h4>
        <div className="flex items-center gap-2 mt-2 text-xs text-foreground-500">
          <span>{work.year}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
          <span className="truncate">饰 {work.role}</span>
        </div>
      </div>
    </Link>
  );
}